



























import { Component, Prop, Vue } from "vue-property-decorator";
import { IRoomServiceRequest } from "@/@types/room-service/room-service";
import RequestCard from "./RequestCard.vue";

@Component({
  components: { RequestCard },
})
class RoomRequestsModal extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: String, default: "" }) roomName!: string;
  @Prop({ type: Array, default: () => [] })
  requests!: IRoomServiceRequest[];

  onOpen(req: IRoomServiceRequest): void {
    this.$emit("open", req);
  }

  close(): void {
    this.$emit("close");
  }
}
export default RoomRequestsModal;
